import { CmsRouteMapping, AdminRouteMapping, SkillSetRouteMapping, ToolkitMbaRouteMapping, OperationalMetricsRouteMapping } from '@astrumu/route-mapping';
const ProductToRouteMapping = {
    cms: CmsRouteMapping,
    admin: AdminRouteMapping,
    skillset: SkillSetRouteMapping,
    'toolkit-mba': ToolkitMbaRouteMapping,
    'operational-metrics': OperationalMetricsRouteMapping
};
let routeMappingInstance;
function useRouteMapping(product) {
    return (routeMappingInstance ??
        (routeMappingInstance = new ProductToRouteMapping[product]()));
}
export default useRouteMapping;
//# sourceMappingURL=index.js.map